// ============================================================
// KONFIGURASI WEBSITE — YOELI CHAN JOURNEY
// Ubah nomor WhatsApp, email, Instagram, dan alamat kantor di sini.
// Edit company contact details here — no code changes needed.
// ============================================================

export const siteConfig = {
  brandName: 'YOELI CHAN JOURNEY',
  tagline: 'Your Journey, Your Way.',
  positioning: {
    id: 'Perjalanan Privat Premium yang Terjangkau',
    en: 'Affordable Premium Private Travel',
  },

  // Nomor WhatsApp bisnis dalam format internasional tanpa tanda "+" atau spasi.
  // Contoh: 085894650337 -> 6285894650337
  whatsappNumber: '6285894650337',
  whatsappDisplay: '+62 858-9465-0337',

  // Placeholder — ganti dengan kontak resmi perusahaan.
  email: 'hello@yoelichanjourney.com',
  instagramHandle: '@yoelichanjourney',
  instagramUrl: 'https://instagram.com/yoelichanjourney',
  officeLocation: {
    id: 'Jakarta, Indonesia (alamat lengkap menyusul)',
    en: 'Jakarta, Indonesia (full address to be announced)',
  },
};

export const waLink = (message) =>
  `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent(message)}`;
